/* eslint-disable camelcase */
export enum SelectedPlansTypes {
  GET_SELECTED_PLAN_REQUEST = '@selected_plan/GET_SELECTED_PLAN_REQUEST',
}

export interface SelectedPlanTypes {
  nome_plano: string;
  statusAssinaturaDigital: boolean;
}

export interface RequestState {
  loading: boolean;
  loaded: boolean;
  error: boolean;
}

export interface SelectedPlansState {
  selectedPlan: SelectedPlanTypes;
  readonly request: RequestState;
}
